<template>
  <div class="smart-recruiters-detail__section smart-recruiters-detail__section-six">
    <grid-columns-fi :container="false">
      <div class="smart-recruiters-detail__container smart-recruiters-detail__about-us">
        <div class="smart-recruiters-detail__text">
          <h3 class="smart-recruiters-detail__about-us-headline">
            {{ fields.headlineCompany?.value }}
          </h3>

          <richtext-fi :html-content="{ value: companyDescription }" />
        </div>
      </div>
      <!-- eslint-enable vue/no-v-html -->
      <div class="smart-recruiters-detail__company smart-recruiters-detail__company--employees">
        <span class="smart-recruiters-detail__company__subtitle">{{
          fields.titleCompanyEmployees?.value
        }}</span>
        <div class="smart-recruiters-detail__company-data">
          {{ fields.countCompanyEmployees?.value }}
        </div>
      </div>
      <div
        class="smart-recruiters-detail__company smart-recruiters-detail__company--national-companies"
      >
        <div class="smart-recruiters-detail__company__subtitle">
          {{ fields.titleCompanyNationalCompanies?.value }}
        </div>
        <div class="smart-recruiters-detail__company-data">
          {{ fields.countCompanyNationalCompanies?.value }}
        </div>
      </div>
      <div class="smart-recruiters-detail__company smart-recruiters-detail__company--countries">
        <div class="smart-recruiters-detail__company__subtitle">
          {{ fields.titleCompanyCountries?.value }}
        </div>
        <div class="smart-recruiters-detail__company-data">
          {{ fields.countCompanyCountries?.value }}
        </div>
      </div>
      <div class="smart-recruiters-detail__company smart-recruiters-detail__company--patents">
        <div class="smart-recruiters-detail__company__subtitle">
          {{ fields.titleCompanyPatents?.value }}
        </div>
        <div class="smart-recruiters-detail__company-data">
          {{ fields.countCompanyPatents?.value }}
        </div>
      </div>
    </grid-columns-fi>
  </div>
</template>

<script setup lang="ts">
import { RichtextFi } from 'atoms';

import GridColumnsFi from '@/components/grid-fi/GridColumnsFi.vue';
import { useFields } from '@/composables/fields';

defineOptions({ name: 'SmartRecruitersDetailSectionSix' });

withDefaults(
  defineProps<{
    companyDescription?: string;
  }>(),
  {
    companyDescription: '',
  },
);

const fields = useFields('SmartRecruitersDetailPageFields');
</script>

<style scoped src="./smart-recruiters-detail-section-six" />
